var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"flex-container-space-between"},[_c('layout-no-padding',[_c('page-title',{attrs:{"routeProps":_vm.routeProps}})],1)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }